import moment from "moment-timezone";
import normalizeText from "./normalizeText";

export function compararArrayOptions(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].value !== arr2[i].value ) {
            return false;
        }
    }

    return true;
}

export function filtrosToString(filtros){

    let resp = `?`;
    
    if(filtros.fecAlt) resp += `fecAltDesdeDate=${filtros.fecAlt.desde.toISOString()}&fecAltHastaDate=${filtros.fecAlt.hasta.toISOString()}`
    
    if(filtros.deliveryDate) resp += `&deliveryDate=${filtros.deliveryDate.toISOString()}`

    return resp;
}

export function addToDate(date, value, unit, operation){
    const newDate = new Date(date); // Clone the original date

    switch (unit) {
        case 'year':
            newDate.setFullYear(newDate.getFullYear() + value);
            break;
        case 'month':
            newDate.setMonth(newDate.getMonth() + value);
            break;
        case 'day':
            (operation == 'add') ? newDate.setDate(newDate.getDate() + value) : newDate.setDate(newDate.getDate() - value);
            break;
        case 'hour':
            newDate.setHours(newDate.getHours() + value);
            break;
        case 'minute':
            newDate.setMinutes(newDate.getMinutes() + value);
            break;
        case 'second':
            newDate.setSeconds(newDate.getSeconds() + value);
            break;
        default:
            throw new Error('Invalid time unit');
    }
    return newDate;
}

export function getDifferenceInDays(date1, date2) {
    
    // Get the time difference in milliseconds
    const timeDifference = Math.abs(date2 - date1);
  
    // Convert the time difference from milliseconds to days
    const differenceInDays = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  
    return differenceInDays;
}

export function getNewFormattedDate(date = null){
    try {
        let now;
        if(date != null){
            now = new Date(date);
        }else{
            now = new Date();
        }

        // Obtener la diferencia en horas entre la zona horaria local (Argentina) y UTC
        const offset = -3; // Argentina está generalmente en UTC-3
        const localDate = new Date(now.getTime() + offset * 60 * 60 * 1000);

        // Formatear la fecha en formato ISO 8601 con el offset `+00:00`
        let formattedDate = localDate.toISOString().replace("Z", "");
        formattedDate = localDate.toISOString().replace("T", " ");    
        let lastIndex = formattedDate.lastIndexOf(".");
        formattedDate = formattedDate.slice(0,lastIndex);

        return  formattedDate
    } catch (error) {
        console.log("error");
        console.log(error);
                    
    }
}

export const modelateUniMed = (uniMed) => {
    switch(uniMed){
        case 'HS':
            return {label:'Horas', value:uniMed}
            break;
        case 'HSsec':
            return {label:'Horas Secundarias', value: uniMed}
            break;
        case 'KM':
            return {label:'Kilometros', value: uniMed}
            break;
        case 'DAYS':
            return {label:'Días', value: uniMed}
            break;
    }
}

export const deepEqual = (a, b) => {
    if (a === b) return true;
  
    // handle Date
    if (a instanceof Date && b instanceof Date) {
      return a.getTime() === b.getTime();
    }
  
    // handle object
    if (typeof a === 'object' && typeof b === 'object' && a && b) {
      const keysA = Object.keys(a);
      const keysB = Object.keys(b);
      if (keysA.length !== keysB.length) return false;
  
      return keysA.every(key => deepEqual(a[key], b[key]));
    }
  
    return false;
  }

  export const checkDoubleQuotes = filter => {
    return typeof filter === 'string' && filter.charAt(0) == '"' && filter.charAt(filter.length - 1) == '"';
  }

  export const removeDoubleQuotesFromFilter = filter => normalizeText(filter.replaceAll('"','')); 